import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { api } from '@utils/api';

const DEV_NEWS_TYPE = {
  FIRST_NEWS: 'first-news',
  NEWS: 'news',
  PLACARD: 'placard',
  ACTIVITY: 'activity'
}

const News = (prop) => {
  const MockNews = [
    {
      title: 'News NewsNewsNewsNewsNewsNews',
      type: 'news',
      mainImage: window.assetUrl(`/images/news/news-main-default.png`)
    },
    {
      title: '【Placard】 NewsNewsNewsNewsNewsNewsNews',
      type: 'placard',
      mainImage: window.assetUrl(`/images/news/news-main-default.png`)
    },
    {
      title: 'News NewsNewsNewsNewsNews',
      type: 'news',
      mainImage: window.assetUrl(`/images/news/news-main-default.png`)
    },
    {
      title: '【Activity} NewsNews',
      type: 'activity',
      mainImage: window.assetUrl(`/images/news/news-main-default.png`)
    },
    {
      title: '【News】 NewsNewsNewsNewsNewsNews',
      type: 'news',
      mainImage: window.assetUrl(`/images/news/news-main-default.png`)
    }
  ];

  const navigate = useNavigate();
  const [newsList, setNewsList] = useState([]);
  const [newsShowList, setNewsShowList] = useState([]);
  const [currentShowIndex, setCurrentShowIndex] = useState(0);
  const [currentType, setCurrentType] = useState(DEV_NEWS_TYPE.FIRST_NEWS);

  const handleTypeChange = (type) => {
    setCurrentType(type);
    let count = 0;
    let showList = [];
    for (let i = 0; i < newsList.length; i++) {
      if (newsList[i].type === type || type === DEV_NEWS_TYPE.FIRST_NEWS) {
        showList.push(newsList[i]);
        count++;
        if (count >= 5) {
          break;
        }
      }
    }
    setNewsShowList(showList);
  }

  const getNewsTypeName = (type) => {
    if(DEV_NEWS_TYPE.FIRST_NEWS === type) {
      return 'all';
    }
    return type;
  }
  
  const getMarkLinePosition = () => {
    switch (currentType) {
      case DEV_NEWS_TYPE.FIRST_NEWS:
        return 'translateX(0)';
      case DEV_NEWS_TYPE.NEWS:
        return 'translateX(108%)';
      case DEV_NEWS_TYPE.PLACARD:
        return 'translateX(218%)';
      case DEV_NEWS_TYPE.ACTIVITY:
        return 'translateX(328%)';
    }
  }

  const getNewsList = async () => {
    try {
      const res = await api.get('/home-news-list');
      setNewsList(res.data.data);
    } catch (error) {
      console.error(error);
    }

  }



  useEffect(() => {
    getNewsList();
  }, []);
  useEffect(() => {
    handleTypeChange(currentType);
  }, [newsList]);

  return (
    <div className="cMainNewsPage">
      <img className="cHeadDownBtn" src={window.assetUrl('/images/home/down.png')} alt="" />
      <div className='cPcTitle'>
        <img className="cBg" src={window.assetUrl('/images/news/title-bg.jpg')} alt="" />
        <img className="cName cTitleInit" src={window.assetUrl('/images/news/title_name.png')} ref={prop.newsPcTitleRef} />
      </div>
      <div className='cPhoneTitle' >
        <img className="cBg" src={window.assetUrl('/images/news/phone/title_bg.jpg')} alt="" />
        <img className="cName cTitleInit" src={window.assetUrl('/images/news/title_name.png')} ref={prop.newsPhoneTitleRef} />
      </div>

      <div className='cContentBox'>
        <img className="cCircle1" src={window.assetUrl('/images/circle.png')} alt="" />
        <img className="cCircle2" src={window.assetUrl('/images/circle.png')} alt="" />
        <div className='cFrameBox'>
          <div className='cFrame'>
            <img src={window.assetUrl('/images/news/frame.png')} alt="" />
            <img className="cNewsMain" src={newsShowList[currentShowIndex]?.main_image_url} alt="" />
          </div>
        </div>
        <div className='cNewsBox'>
          <div className='cControlBox'>
            <img className="cButton" src={window.assetUrl('/images/news/first-news.png')} alt="" onClick={() => { handleTypeChange(DEV_NEWS_TYPE.FIRST_NEWS) }} />
            <img className="cButton" src={window.assetUrl('/images/news/news.png')} alt="" onClick={() => { handleTypeChange(DEV_NEWS_TYPE.NEWS) }} />
            <img className="cButton" src={window.assetUrl('/images/news/placard.png')} alt="" onClick={() => { handleTypeChange(DEV_NEWS_TYPE.PLACARD) }} />
            <img className="cButton" src={window.assetUrl('/images/news/activity.png')} alt="" onClick={() => { handleTypeChange(DEV_NEWS_TYPE.ACTIVITY) }} />
            <img className="cMore" src={window.assetUrl('/images/news/more.png')} alt="" onClick={() => { navigate('/news') }} />
          </div>
          <div className='cNewsSummary'>
            <img className="cFrame" src={window.assetUrl('/images/news/news-fram.png')} alt="" />
            <img className="cMarkLine" src={window.assetUrl('/images/news/mark-line.png')}
              style={{ transform: getMarkLinePosition() }} />
            <div className='cListBox'>
              {newsShowList.map((news, index) => (
                <div key={index} className='cNewsSummaryItem' onClick={() => { navigate(`/news/${news.id}?type=${getNewsTypeName(currentType)}`) }} onMouseEnter={() => { setCurrentShowIndex(index) }}>
                  <img className="cType" src={window.assetUrl(`/images/news/type-${news.type}.png`)} alt="" />
                  <div className='cTitle'>{news.title}</div>
                </div>
              ))
              }
            </div>
          </div>
        </div>
      </div>
      <img className="cDownBtn" src={window.assetUrl('/images/home/down.png')} alt="" />
    </div>
  );
};

export default News;

